

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADPDFBYNAME= createAsyncThunk(
  "updateSubDepartment/downloadPdfByName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadPdfByNameSlice = createSlice({
  name: "downloadPdfByNameSlice",
  initialState: {
    downloadPdfByName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadPdfByName: (state) => {
        state.downloadPdfByName.loading = false
        state.downloadPdfByName.error = false
        state.downloadPdfByName.data = []
        state.downloadPdfByName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADPDFBYNAME.fulfilled, (state, action) => {
      state.downloadPdfByName = {
        ...state.downloadPdfByName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADPDFBYNAME.pending, (state, action) => {
      state.downloadPdfByName = {
        ...state.downloadPdfByName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADPDFBYNAME.rejected, (state, action) => {
      state.downloadPdfByName = {
        ...state.downloadPdfByName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadPdfByNameAction = {
    DOWNLOADPDFBYNAME,
};

export { downloadPdfByNameAction };
export default downloadPdfByNameSlice.reducer;
export const {setInitialStateOfdownloadPdfByName} = downloadPdfByNameSlice.actions
